module.exports = __webpack_public_path__ + "img/zc.29aa8fa6.png";